/**
 * The one live offer store (2.L deliverable 11): a module-level holder of the pure state in
 * `core/offers.ts`, read by `UndoToastHost` through `useSyncExternalStore` and written by
 * `undoable`.
 */
import { close, NO_OFFER, type OfferState, offer, type UndoOffer } from './core/offers.js';

let state: OfferState = NO_OFFER;
const listeners = new Set<() => void>();

function set(next: OfferState): void {
  if (next === state) return;
  state = next;
  for (const listener of [...listeners]) listener();
}

export const offerStore = {
  get: (): OfferState => state,
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  offer: (next: UndoOffer): void => set(offer(state, next)),
  close: (batchId: string): void => set(close(state, batchId)),
  reset: (): void => set(NO_OFFER),
};
